import * as Sentry from "@sentry/react";
import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      Sentry.captureException(error, {
        level: "error",
        extra: {
          url: error.config.url,
          method: error.config.method,
          status: error.response.status,
          responseData: error.response.data,
          headers: error.config.headers,
        },
        tags: {
          api_error: true,
          status: error.response.status,
        },
      });
    } else {
      Sentry.captureException(error, {
        level: "error",
        extra: {
          message: error.message,
        },
      });
    }
    return Promise.reject(error);
  },
);

export default api;
